import { useQuery } from '@apollo/client';

import type {
  FetchTrackedSkillsQuery,
  FetchTrackedSkillsQueryVariables,
} from 'bundles/skills-common/private/admin-skill-tracking/data/__generated__/fetchTrackedSkillsData';
import fetchTrackedSkillsData from 'bundles/skills-common/private/admin-skill-tracking/data/fetchTrackedSkillsData.graphql';
import { getMetricsTimeFrame } from 'bundles/skills-common/private/admin-skill-tracking/data/useFetchTrendingSkills';

const useTrackedSkills = (orgId: string, numOfPrevDays: number) => {
  const { loading, data, error } = useQuery<FetchTrackedSkillsQuery, FetchTrackedSkillsQueryVariables>(
    fetchTrackedSkillsData,
    {
      variables: {
        orgId,
        metricsTimeFrame: getMetricsTimeFrame(numOfPrevDays),
      },
      context: {
        clientName: 'gatewayGql',
      },
    }
  );

  const skills = data?.EnterpriseSkillsInsights?.querySkillsInsightsByOrg?.trackedSkillsInsights ?? [];
  const sortedSkills = [...skills].sort((skillA, skillB) => skillB.numOfLearners - skillA.numOfLearners);

  return {
    isLoading: loading,
    hasError: !!error,
    skills: sortedSkills.slice(0, 5).map((skill) => ({
      rank: skill.rank,
      skillName: skill.skillName,
      skillId: skill.skillId,
      numOfLearners: skill.numOfLearners,
      changePercentage: skill.changePercentage,
    })),
  };
};

export default useTrackedSkills;
